import { createSlice } from "@reduxjs/toolkit";

const InitialValue = {
  headerName: null,
  activeMenu: null,
  showPreloader: false,
  translationState: true,
  typingMode: "tanglish",
};
const ActivePageSlice = createSlice({
  name: "ActivePageSlice",
  initialState: InitialValue,
  reducers: {
    setActivePage: (state, action) => {
      state.activeMenu = action.payload.activeMenu;
      state.headerName = action.payload.headerName;
    },
    setShowPreloader: (state, action) => {
      state.showPreloader = action.payload;
    },
    setTranslationState: (state, action) => {
      state.translationState = action.payload;
      state.typingMode = action.payload ? "tanglish" : "english";
    },
    setTypingMode: (state, action) => {
      const nextTypingMode =
        action.payload === "english" ? "english" : "tanglish";
      state.typingMode = nextTypingMode;
      state.translationState = nextTypingMode === "tanglish";
    },
  },
});

export const {
  setActivePage,
  setShowPreloader,
  setTranslationState,
  setTypingMode,
} = ActivePageSlice.actions;
export default ActivePageSlice.reducer;
